module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "ui basic inverted button",
    class: _vm.termsAccepted ? '' : 'disabled',
    attrs: {
      "href": "https://shifty.aragon.one"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Buy with other cryptocurrencies")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610b83cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shifty.vue
// module id = 514
// module chunks = 1